import Config from 'react-native-config';
import { Dispatch } from 'redux';

import DeviceInfoServices from 'services/DeviceInfoServices';
import FileServices from 'services/FileServices';
import { apiKeySelector } from 'store/appSettings/selectors';
import { dfdAccessTokenSelector, fhirCurrentUserPatientId } from 'store/authentication/selectors';
import { consumerIdSelector } from 'store/profile/selectors';
import { RootState, Thunk } from 'store/types';
import { eobDownloadingSelector } from './selectors';

export const GET_EOB_DOCUMENTS = 'EOB_DOCUMENT.GET_DOCUMENTS';
export const GET_EOB_DOCUMENTS_SUCCESS = 'EOB_DOCUMENT.GET_DOCUMENTS_SUCCESS';
export const GET_EOB_DOCUMENTS_FAIL = 'EOB_DOCUMENT.GET_DOCUMENTS_FAIL';
export const getEobDocuments = (claimId: string | null): Thunk => dispatch => {
  dispatch({
    type: GET_EOB_DOCUMENTS,
    payload: {
      client: 'eob',
      request: {
        responseType: 'arraybuffer',
        method: 'get',
        url: `?claimId=${claimId}`
      }
    }
  });
};

/**
 * Download EOB
 */
export const DOWNLOAD_EOB = 'EOB_DOCUMENT.DOWNLOAD_EOB';
export const DOWNLOAD_EOB_SUCCESS = 'EOB_DOCUMENT.DOWNLOAD_EOB_SUCCESS';
export const DOWNLOAD_EOB_FAIL = 'EOB_DOCUMENT.DOWNLOAD_EOB_FAIL';

export const downloadEob = (claimId: string) => async (
  dispatch: Dispatch,
  getState: () => RootState
) => {
  const state = getState();

  // Check for in flight downloads if there are any then return
  if (eobDownloadingSelector(state) === true) {
    return;
  }

  dispatch({ type: DOWNLOAD_EOB, payload: {} });

  const patientId = fhirCurrentUserPatientId(state);
  const accessToken = dfdAccessTokenSelector(state);
  const apikey = apiKeySelector(state);
  const consumerId = consumerIdSelector(state);
  const deviceId = DeviceInfoServices.getDeviceId();
  const timestamp = Date.now();

  try {
    const response = await FileServices.download(
      `eob-${timestamp}.pdf`,
      `${Config.GRAPHQL_EOB_ENDPOINT_URL}?claimId=${claimId}`,
      {
        Authorization: `Bearer ${accessToken}`,
        apikey,
        'x-device-id': deviceId,
        'x-dfd-consumer-id': consumerId,
        'x-patient-id': patientId
      }
    );

    dispatch({ type: DOWNLOAD_EOB_SUCCESS, payload: { response } });
  } catch (err) {
    dispatch({ type: DOWNLOAD_EOB_FAIL, error: err });
  }
};
